import type { BuisnessFunctionListItem } from '../types';

export type BuisnessFunctionListRow = BuisnessFunctionListItem;

export const businessFunctionMockData: BuisnessFunctionListRow[] = [
  { id: 'recruiting', name: 'Recruiting', administrator: 'Andrew Smith', state: 'CREATED' },
  { id: 'people-management', name: 'People management', administrator: 'Andrew Smith', state: 'CREATED' },
  { id: 'finance-and-legal', name: 'Finance and Legal', administrator: 'John Lee', state: 'SUSPENDED' },
  { id: 'business-management', name: 'Business management', administrator: 'Alice Chain', state: 'CREATED' },
  {
    id: 'delivery',
    name: 'Delivery',
    administrator: 'John Lee',
    state: 'ACTIVE',
    children: [
      {
        id: 'project-x',
        name: 'Project X',
        administrator: 'John Lee',
        state: 'ACTIVE',
        children: [
          {
            id: 'project-x-platform',
            name: 'Platform',
            administrator: 'Alice Chain',
            state: 'ACTIVE',
            children: [
              { id: 'project-x-backend', name: 'Backend', administrator: 'John Lee', state: 'ACTIVE' },
              { id: 'project-x-frontend', name: 'Frontend', administrator: 'Alice Chain', state: 'ACTIVE' },
            ],
          },
        ],
      },
      { id: 'polaris', name: 'Polaris', administrator: 'Alice Chain', state: 'ACTIVE' },
      { id: 'lumen', name: 'Lumen', administrator: 'John Lee', state: 'ACTIVE' },
      { id: 'oreo', name: 'Oreo', administrator: 'Alice Chain', state: 'ACTIVE' },
      { id: 'nimbus', name: 'Nimbus', administrator: 'Alice Chain', state: 'ACTIVE' },
      { id: 'helios', name: 'Helios', administrator: 'John Lee', state: 'ACTIVE' },
      { id: 'atlas', name: 'Atlas', administrator: 'Alice Chain', state: 'ACTIVE' },
      { id: 'vega', name: 'Vega', administrator: 'John Lee', state: 'ACTIVE' },
    ],
  },
  { id: 'security-and-compliance', name: 'Security and compliance', administrator: 'Andrew Smith', state: 'SUSPENDED' },
  { id: 'sales', name: 'Sales', administrator: 'Andrew Smith', state: 'ACTIVE' },
  { id: 'rnd', name: 'RnD', administrator: 'Andrew Smith', state: 'ACTIVE' },
  { id: 'marketing', name: 'Marketing', administrator: 'Andrew Smith', state: 'ACTIVE' },
];
